import React, { useState } from 'react';
import { Card, Typography, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { UploadOutlined } from '@ant-design/icons';
import { ResidentsBulkUploadModal } from '@/components/features/resources/residents/ResidentsBulkUploadModal';

const { Title, Text } = Typography;

interface BulkResidentsCardProps {
  onNext: () => void;
}

export const BulkResidentsCard: React.FC<BulkResidentsCardProps> = ({
  onNext
}) => {
  const { t } = useTranslation(['residents', 'common']);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleBulkUploadSuccess = () => {
    setIsModalOpen(false);
    onNext();
  };

  return (
    <>
      <Card style={{ width: '100%', maxWidth: 600, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', padding: '40px 20px' }}>
          <Title level={2} style={{ color: '#1890ff', marginBottom: '16px' }}>
            {t('residents:bulkUpload.title')}
          </Title>
          
          <Text type="secondary" style={{ fontSize: '16px', marginBottom: '32px', display: 'block' }}>
            You have more than 40 apartment units. Use the bulk upload feature to add residents efficiently.
          </Text>

          <Button 
            type="primary" 
            icon={<UploadOutlined />}
            onClick={handleModalOpen}
            size="large"
            style={{ marginTop: '24px' }}
          >
            Open Bulk Upload
          </Button>
        </div>
      </Card>

      <ResidentsBulkUploadModal
        visible={isModalOpen}
        onCancel={handleModalClose}
        onSuccess={handleBulkUploadSuccess}
      />
    </>
  );
};